import { defineStore } from 'pinia'
import axios from '../axios'
export const useFixtureStore = defineStore('fixtures', {
  state: () => ({
    fixtures: [
      {
        id: '22197',
        date: '2024-12-08',
        time: '17:00:00',
        homeTeam: 'Viimsi',
        awayTeam: 'Latvijas Universitate',
        league: 'NBA',
        status: 'Active',
        lastUpdated: '2024-12-06 18:58:06'
      },
      {
        id: '22198',
        date: '2024-12-08',
        time: '19:30:00',
        homeTeam: 'BC Kalev/Cramo',
        awayTeam: 'Valmiera Glass/VIA',
        league: 'NBA',
        status: 'Active',
        lastUpdated: '2024-12-06 19:00:00'
      },
      {
        id: '22199',
        date: '2024-12-09',
        time: '18:00:00',
        homeTeam: 'BK Liepaja',
        awayTeam: 'BK Ogre',
        league: 'WNBA',
        status: 'Scheduled',
        lastUpdated: '2024-12-06 20:15:00'
      },
      {
        id: '22200',
        date: '2024-12-09',
        time: '20:00:00',
        homeTeam: 'Keila Coolbet',
        awayTeam: 'Pärnu Sadam',
        league: 'WNBA',
        status: 'Active',
        lastUpdated: '2024-12-06 21:30:00'
      },
      {
        id: '22201',
        date: '2024-12-10',
        time: '18:30:00',
        homeTeam: 'Los Angeles Lakers',
        awayTeam: 'Boston Celtics',
        league: 'NBA',
        status: 'Scheduled',
        lastUpdated: '2024-12-07 10:00:00'
      },
      {
        id: '22202',
        date: '2024-12-10',
        time: '20:00:00',
        homeTeam: 'Golden State Warriors',
        awayTeam: 'Phoenix Suns',
        league: 'NBA',
        status: 'Scheduled',
        lastUpdated: '2024-12-07 10:15:00'
      },
      {
        id: '22203',
        date: '2024-12-11',
        time: '19:00:00',
        homeTeam: 'Las Vegas Aces',
        awayTeam: 'Seattle Storm',
        league: 'WNBA Play-Offs',
        status: 'Scheduled',
        lastUpdated: '2024-12-07 11:00:00'
      },
      {
        id: '22204',
        date: '2024-12-11',
        time: '20:30:00',
        homeTeam: 'New York Liberty',
        awayTeam: 'Connecticut Sun',
        league: 'WNBA Play-Offs',
        status: 'Scheduled',
        lastUpdated: '2024-12-07 11:30:00'
      },
      {
        id: '22205',
        date: '2024-12-12',
        time: '18:00:00',
        homeTeam: 'Real Madrid',
        awayTeam: 'FC Barcelona',
        league: 'Euroleague',
        status: 'Scheduled',
        lastUpdated: '2024-12-07 12:00:00'
      },
      {
        id: '22206',
        date: '2024-12-12',
        time: '19:45:00',
        homeTeam: 'Olympiacos',
        awayTeam: 'Fenerbahce',
        league: 'Euroleague',
        status: 'Scheduled',
        lastUpdated: '2024-12-07 12:30:00'
      },
      {
        id: '22207',
        date: '2024-12-13',
        time: '17:30:00',
        homeTeam: 'Zalgiris Kaunas',
        awayTeam: 'CSKA Moscow',
        league: 'EuroCup',
        status: 'Scheduled',
        lastUpdated: '2024-12-07 13:00:00'
      },
      {
        id: '22208',
        date: '2024-12-13',
        time: '20:00:00',
        homeTeam: 'Valencia Basket',
        awayTeam: 'Virtus Bologna',
        league: 'EuroCup',
        status: 'Scheduled',
        lastUpdated: '2024-12-07 13:30:00'
      }
    ],
    stats: {
      totalFixtures: 70,
      todaysGames: 12,
      thisMonth: 60,
      lastMonthChange: 12,
      yesterdayChange: -3,
      lastMonthChangeMonth: 8
    },
    leagues: [],
    purchasedGames: [],
    gamePrices: {
      'NBA': 29.99,
      'WNBA': 24.99,
      'WNBA Play-Offs': 34.99,
      'Latvian-Estonian Basketball League': 29.99,
      'Euroleague': 29.99,
      'EuroCup': 24.99,
      '22201': 49.99,
      '22203': 39.99,
      '22205': 44.99,
      '22207': 34.99
    },
    gameAvailability: {
      'NBA': true,
      'WNBA': true,
      'WNBA Play-Offs': true,
      'Euroleague': true,
      'EuroCup': true
    },
    premiumGames: {
      '22201': true,
      '22203': true,
      '22205': true,
      '22207': true
    },
    loading: false,
    dateRange: {
      start: null,
      end: null
    }
  }),

  getters: {
    getFixturesByLeague: (state) => (league) => {
      return state.fixtures.filter(fixture => fixture.league === league)
    },
    getActiveFixtures: (state) => {
      return state.fixtures.filter(fixture => fixture.status === 'Active')
    },
    getScheduledFixtures: (state) => {
      return state.fixtures.filter(fixture => fixture.status === 'Scheduled')
    },
    getTodaysFixtures: (state) => {
      const today = new Date().toISOString().split('T')[0]
      return state.fixtures.filter(fixture => fixture.date === today)
    },
    isGamePurchased: (state) => (fixtureId, userId) => {
      return state.purchasedGames.some(p => 
        p.fixtureId === fixtureId && p.userId === userId
      )
    },
    getGamePrice: (state) => (fixture) => {
      if (state.gamePrices[fixture.id]) {
        return state.gamePrices[fixture.id]
      }
      return state.gamePrices[fixture.league] || 29.99
    },
    isGameAvailable: (state) => (league) => {
      return state.gameAvailability[league] || false
    },
    isPremiumGame: (state) => (fixtureId) => {
      return state.premiumGames[fixtureId] || false
    },
    filteredFixtures: (state) => {
      if (!state.dateRange.start || !state.dateRange.end) {
        return state.fixtures
      }

      const startDate = new Date(state.dateRange.start)
      const endDate = new Date(state.dateRange.end)
      startDate.setHours(0, 0, 0, 0)
      endDate.setHours(23, 59, 59, 999)

      return state.fixtures.filter(fixture => {
        const fixtureDate = new Date(fixture.date)
        return fixtureDate >= startDate && fixtureDate <= endDate
      })
    }
  },

  actions: {
    async getFixtures() {
      try {
        // If we already have fixtures, return them
        if (this.fixtures && this.fixtures.length > 0) {
          return this.fixtures
        }
        
        // Otherwise, try to fetch from API
        // For now, we'll return the existing fixtures from state
        // You can implement API call here when endpoint is available
        return this.fixtures
      } catch (error) {
        console.error('Error fetching fixtures:', error)
        return []
      }
    },
    async getLeagues() {
      try {
        const response = await axios.get('/api/leagues/get-leagues') 
        this.leagues = response.data
        return this.leagues
      } catch (error) {
        console.error('Error fetching leagues:', error)
        return []
      }
    },
    async getPlayerProjections(fixtureId) {
      try {
        const response = await axios.get(`${import.meta.env.VITE_LEGACY_API_URL || 'https://api.hel-rob.oddscomposer.io'}/api/markets/get-team-players-from-roster-template`, {
          params: { scheduleId: fixtureId }
        })
        return response.data
      } catch (error) {
        console.error('Error fetching player projections:', error)
        return null
      }
    },
    async getFixturesByLeagueId(leagueId) {
      try {
        const response = await axios.get(`/api/v2/scheduled-games-by-league/${leagueId}`)
        const formattedFixtures = response.data.map(fixture => ({
          id: fixture.id,
          date: fixture.datetime?.split(' ')[0],
          time: fixture.datetime?.split(' ')[1],
          homeTeam: fixture.team1,
          awayTeam: fixture.team2,
          league: fixture.league_name || 'Unknown League',
          status: 'Scheduled',
          lastUpdated: fixture.updated_at
        }))
        this.fixtures = formattedFixtures
        return formattedFixtures
      } catch (error) {
        console.error('Error fetching fixtures by league:', error)
        return []
      }
    },
    addFixture(fixture) {
      this.fixtures.push({
        ...fixture,
        id: `${Date.now()}`,
        lastUpdated: new Date().toISOString(),
        status: 'Scheduled'
      })
    },
    updateFixture(id, updates) {
      const index = this.fixtures.findIndex(f => f.id === id)
      if (index !== -1) {
        this.fixtures[index] = {
          ...this.fixtures[index],
          ...updates,
          lastUpdated: new Date().toISOString()
        }
      }
    },
    deleteFixture(id) {
      this.fixtures = this.fixtures.filter(f => f.id !== id)
    },
    purchaseGame(fixtureId, userId) {
      const fixture = this.fixtures.find(f => f.id === fixtureId)
      if (fixture) {
        this.purchasedGames.push({
          fixtureId,
          userId,
          purchaseDate: new Date().toISOString(),
          league: fixture.league,
          price: this.gamePrices[fixture.league],
          status: 'active'
        })
      }
    },
    hasGameAccess(fixtureId, userId, userSubscription) {
      if (this.premiumGames[fixtureId]) {
        return this.isGamePurchased(fixtureId, userId)
      }
      return true
    },
    getFixtureById(id) {
      return this.fixtures.find(fixture => fixture.id === id)
    },
    async fetchFixturesByRange(days) {
      this.loading = true
      try {
        const endDate = new Date()
        const startDate = new Date()
        startDate.setDate(endDate.getDate() - days + 1) // +1 to include today
        
        this.dateRange = {
          start: startDate.toISOString().split('T')[0],
          end: endDate.toISOString().split('T')[0]
        }

        return this.filteredFixtures
      } catch (error) {
        console.error('Error fetching fixtures by range:', error)
        return []
      } finally {
        this.loading = false
      }
    },
    async fetchFixturesByCustomRange(startDate, endDate) {
      this.loading = true
      try {
        this.dateRange = {
          start: startDate,
          end: endDate
        }

        // If you have an API endpoint, you can use it here
        // const response = await axios.get(`/api/fixtures?from=${startDate}&to=${endDate}`)
        // this.fixtures = response.data

        // For now, we'll just filter the existing fixtures
        return this.filteredFixtures
      } catch (error) {
        console.error('Error fetching fixtures by custom range:', error)
        return []
      } finally {
        this.loading = false
      }
    }
  }
}) 